import JsonLd from "@/components/JsonLd.tsx";
import JsonLdBreadcrumbList from "@/components/JsonLdBreadcrumbList.tsx";
import {createFileRoute} from '@tanstack/react-router'
import ContactPage from "../landing/ContactPage.tsx";

export const Route = createFileRoute('/contact')({
    component: RouteComponent,
})

function RouteComponent() {
    return <>
        <JsonLd id={`page${Route.id}/contact`} item={{
            "@context":    "https://schema.org",
            "@type":       "ContactPage",
            "url":         "https://scorepal.co/contact/",
            "name":        "Contact ScorePal",
            "description": "Easily create and manage tournament brackets with automated scheduling, player seeding, and real-time match updates using ScorePal. Proven performance over the past 2 years.",
            "mainEntity":  {
                "@type":        "Organization",
                "name":         "ScorePal",
                "url":          "https://scorepal.co",
                "contactPoint": {
                    "@type":             "ContactPoint",
                    "contactType":       "customer support",
                    "availableLanguage": "English"
                }
            }
        }} />
        <JsonLdBreadcrumbList routeId={Route.id} crumbs={[{name: "Contact", item: "https://scorepal.co/contact/"}]} />
        <ContactPage />
    </>
}
